import type { FC } from "react";
import React from "react";

import { CATEGORY_META, CATEGORY_ORDER } from "../../../bootstrap/category.ts";

export const Legend: FC = () => (
  <div
    className="flex flex-wrap items-center justify-center gap-x-3 gap-y-[5px] px-3.5"
    style={{ paddingBottom: "max(var(--safe-bottom, 0px), 30px)" }}
  >
    {CATEGORY_ORDER.map(category => (
      <span
        className="inline-flex items-center gap-[5px] text-[10.5px] text-muted-foreground"
        key={category}
      >
        <span
          className="size-[9px] rounded-[2.5px]"
          style={{ backgroundColor: CATEGORY_META[category].color }}
        />
        {CATEGORY_META[category].label}
      </span>
    ))}
  </div>
);
